// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetRealtorsRequest,
  TGetRealtorsModel,
  IMappers,
  TGetRealtorsResponse,
  IGetRealtorsResponse,
  IGetRealtorsResponseError,
} from './types';

export const defaultConfig: TGetRealtorsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'agent-catalog-search',
  pathApi: '/v1/get-realtors/',
} as TGetRealtorsModel;

export function createGetRealtorsModel(parameters: IGetRealtorsRequest): TGetRealtorsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetRealtorsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetRealtorsRequest;
}

export async function fetchGetRealtors<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetRealtorsOptions<TResponse200, TResponse400>): Promise<TGetRealtorsResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetRealtorsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRealtorsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetRealtorsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetRealtorsResponse;
}
